import React, {
    useState
} from 'react';


import HeaderUno
    from '../Metodos/Compartidos/HeaderUno';

import HeaderDos
    from '../Metodos/Compartidos/HeaderDos';


import ObjetivosDisponibles
    from './ObjetivosDisponibles';

import ObjetivosAsignados
    from './ObjetivosAsignados';


// css
import {
    Cuerpo
} from '../Css/StyledHeader';


import {

    ContenedorObjetivos,
    AreasObjetivos,
    BotonAreaObjetivo,
    TabsObjetivos,
    TabObjetivo,
    PanelObjetivos

} from '../Css/StyledObjetivos';



const objetivosSeccion = [

    {
        id:
            '1',

        seccion_objetivo:
            'LECTURA'
    },

    {
        id:
            '2',

        seccion_objetivo:
            'ESCRITURA'
    },

    {
        id:
            '3',

        seccion_objetivo:
            'CC FONOLÓGICA'
    },

    {
        id:
            '4',

        seccion_objetivo:
            'DENOMINACIÓN RÁPIDA'
    },

    {
        id:
            '5',

        seccion_objetivo:
            'MATEMÁTICA'
    },

    {
        id:
            '6',

        seccion_objetivo:
            'COGNICIÓN'
    },

    {
        id:
            '7',

        seccion_objetivo:
            'EMOCIÓN'
    },

    {
        id:
            '8',

        seccion_objetivo:
            'LENGUAJE'
    }

];



const Objetivos = () => {


    const [
        seccionObjetivo,
        setSeccionObjetivo
    ] = useState({

        id:
            objetivosSeccion[0].id,

        seccion:
            objetivosSeccion[0]
                .seccion_objetivo

    });


    /*
    ====================================
    MANTENEMOS EL COMPORTAMIENTO ACTUAL
    ====================================

    Actualmente la pantalla abre en
    Objetivos Asignados.

    No lo cambiamos por el prototipo
    para no alterar comportamiento.
    ====================================
    */

    const [
        objetivosEtapa,
        setObjetivosEtapa
    ] = useState(
        'asignados'
    );



    return (

        <Cuerpo>


            <HeaderUno />


            <HeaderDos

                link={
                    `/escritorio/pacientes/paciente`
                }

                componente={
                    "Objetivos"
                }

                paciente={
                    true
                }

            />


            <ContenedorObjetivos>


                {/*
                ====================================
                ÁREAS
                ====================================
                */}


                <AreasObjetivos>


                    {
                        objetivosSeccion.map(
                            item => (

                                <BotonAreaObjetivo

                                    key={
                                        item.id
                                    }

                                    type="button"

                                    activo={
                                        seccionObjetivo.seccion ===
                                        item.seccion_objetivo
                                    }

                                    onClick={
                                        () =>
                                            setSeccionObjetivo({

                                                id:
                                                    item.id,

                                                seccion:
                                                    item.seccion_objetivo

                                            })
                                    }

                                >

                                    {
                                        item.seccion_objetivo
                                    }

                                </BotonAreaObjetivo>

                            )
                        )
                    }


                </AreasObjetivos>


                {/*
                ====================================
                DISPONIBLES / ASIGNADOS
                ====================================
                */}


                <TabsObjetivos>


                    <TabObjetivo

                        type="button"

                        activo={
                            objetivosEtapa ===
                            "disponible"
                        }

                        onClick={
                            () =>
                                setObjetivosEtapa(
                                    "disponible"
                                )
                        }

                    >

                        Objetivos Disponibles

                    </TabObjetivo>


                    <TabObjetivo

                        type="button"

                        activo={
                            objetivosEtapa ===
                            "asignados"
                        }

                        onClick={
                            () =>
                                setObjetivosEtapa(
                                    "asignados"
                                )
                        }

                    >

                        Objetivos Asignados

                    </TabObjetivo>


                </TabsObjetivos>


                {/*
                ====================================
                CONTENIDO
                ====================================
                */}


                <PanelObjetivos>


                    {
                        objetivosEtapa ===
                        "disponible"
                            ?

                            <ObjetivosDisponibles

                                seccion={
                                    seccionObjetivo
                                }

                            />

                            :

                            null
                    }


                    {
                        objetivosEtapa ===
                        "asignados"
                            ?

                            <ObjetivosAsignados

                                seccion={
                                    seccionObjetivo
                                }

                            />

                            :

                            null
                    }


                </PanelObjetivos>


            </ContenedorObjetivos>


        </Cuerpo>

    );

};


export default Objetivos;